// src/components/common/SelectInput.tsx

import React from 'react';

interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  className?: string;
}

const SelectInput: React.FC<SelectInputProps> = ({
  label,
  error,
  icon,
  className = '',
  children,
  ...props
}) => {
  return (
    <div className={className}>
      {label && (
        <label className=" text-sm font-medium text-neutral-700 mb-1 flex items-center">
          {icon && <span className="mr-2">{icon}</span>}
          {label}
        </label>
      )}
      
      <div className="relative">
        <select
          className={`w-full px-3 py-2 border ${props.disabled ? 'bg-neutral-50 text-neutral-500' : 'bg-white'} 
            border-neutral-200 rounded-lg ${error ? 'border-error-500' : ''} 
            focus:outline-none focus:ring-1 focus:ring-brand-blue appearance-none`}
          {...props}
        >
          {children}
        </select>
        
        {/* 自定義箭頭 */}
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg className="w-4 h-4 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>
      
      {error && (
        <div className="text-sm text-error-600 mt-1">{error}</div>
      )}
    </div>
  );
};

export default SelectInput;